/* eslint-disable react/forbid-prop-types */
import React from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import {
  Navbar,
  Nav,
  NavDropdown,
  MenuItem,
  NavItem,
} from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';

import { logoutUser } from '../../features/authentication/actions';
import { getUserFeatures } from '../../features/authentication/selectors';
import { getEnvironmentColor } from '../../features/configuration/selectors';
import logo from '../../images/HSI_logo_no_subtext.png';
import { getShowHeader } from '../../app/selectors';

const proptypes = ({
  onLogout: PropTypes.func.isRequired,
  features: PropTypes.object.isRequired,
  environmentColor: PropTypes.string.isRequired,
  showHeader: PropTypes.bool,
});

export const Header = (props) => {
  const {
    admin, approval, payroll,
    per_diem_request: perDiemRequest,
    per_diem: perDiem,
    trir_report: trirReport,
    viewer,
  } = props.features;

  const { environmentColor } = props;

  const renderInboxList = () => {
    if (!admin) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="1"
        title="Inbox"
      >
        <label>Processing</label>
        <LinkContainer to="/submissions/processor">
          <MenuItem eventKey="1.1">
            Inbox
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/bonuses">
          <MenuItem eventKey="1.4">
            Bonus Inbox
          </MenuItem>
        </LinkContainer>

        <label>Status Reports</label>
        <LinkContainer to="/submissions/status/timesheets">
          <MenuItem eventKey="1.2">
            Timesheet Collection
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/submissions/status/tickets">
          <MenuItem eventKey="1.3">
            Missing Tickets
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/submissions/status/gap_detector">
          <MenuItem eventKey="1.5">
            Ticket Gap Detector
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderSubmissionList = () => {
    if (!admin && !viewer) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="2"
        title="Submissions"
      >
        {admin
          && (
          <LinkContainer to="/submissions/timesheets">
            <MenuItem eventKey="2.1">
              Timesheets
            </MenuItem>
          </LinkContainer>
          )}

        <LinkContainer to="/submissions/tickets">
          <MenuItem eventKey="2.2">
            Tickets
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderReviewList = () => {
    if (!admin) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="9"
        title="Review"
      >
        <LinkContainer to="/review/tickets">
          <MenuItem eventKey="9.1">
            Jobs
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderApprovalList = () => {
    if (!approval) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="3"
        title="Approvals"
      >
        <LinkContainer to="/approvals/timesheets">
          <MenuItem eventKey="3.1">
            Timesheets
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/approvals/tickets">
          <MenuItem eventKey="3.2">
            Jobs
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/approvals/bonuses">
          <MenuItem eventKey="3.3">
            Bonuses
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderReportList = () => {
    if (!admin) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="4"
        title="Reports"
      >
        <LinkContainer to="/reports/weekly-hours">
          <MenuItem eventKey="4.1">
            Weekly Hours
          </MenuItem>
        </LinkContainer>

        {trirReport
          && (
          <LinkContainer to="/reports/trir">
            <MenuItem eventKey="4.2">
              TRIR Report
            </MenuItem>
          </LinkContainer>
          )}
        <LinkContainer to="/reports/unaccounted-hours-tickets">
          <MenuItem eventKey="4.3">
            Tickets with Unaccounted Hours Report
          </MenuItem>
        </LinkContainer>
        {payroll
          && (
          <LinkContainer to="/reports/guaranteed-hours">
            <MenuItem eventKey="4.4">
              Guaranteed Hours Report
            </MenuItem>
          </LinkContainer>
          )}
        <LinkContainer to="/reports/equipment-usage">
          <MenuItem eventKey="4.5">
            Equipment Usage Report
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderAccountingList = () => {
    if (!payroll) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="5"
        title="Accounting"
      >
        <LinkContainer to="/accounting/invoicing">
          <MenuItem eventKey="5.1">
            Invoicing
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/accounting/payroll">
          <MenuItem eventKey="5.2">
            Payroll
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/accounting/bonuses">
          <MenuItem eventKey="5.3">
            Bonuses
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/export-deferred-jobs">
          <MenuItem eventKey="5.4">
            Export Deferred Jobs
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/accounting/accrual-report">
          <MenuItem eventKey="5.5">
            Accrual Report
          </MenuItem>
        </LinkContainer>

      </NavDropdown>
    );
  };

  const renderAdminList = () => {
    if (!admin) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="6"
        title="Admin"
      >
        <LinkContainer to="/admin/users">
          <MenuItem eventKey="6.1">
            Users
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/admin/equipment">
          <MenuItem eventKey="6.2">
            Equipment
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/admin/operators">
          <MenuItem eventKey="6.3">
            Operators
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/admin/leases">
          <MenuItem eventKey="6.4">
            Leases
          </MenuItem>
        </LinkContainer>

        <LinkContainer to="/admin/wells">
          <MenuItem eventKey="6.5">
            Wells
          </MenuItem>
        </LinkContainer>
        <LinkContainer to="/admin/mobile-password">
          <MenuItem eventKey="6.6">
            Request Mobile Password
          </MenuItem>
        </LinkContainer>
      </NavDropdown>
    );
  };

  const renderPerDiemList = () => {
    const canSeePerDiems = (perDiemRequest || perDiem);
    if (!canSeePerDiems) {
      return null;
    }

    return (
      <NavDropdown
        id="nav-header-dropdown"
        eventKey="8"
        title="Per Diem"
      >
        {perDiemRequest
          && (
          <LinkContainer to="/per-diem/requests">
            <MenuItem eventKey="8.1">
              Requests
            </MenuItem>
          </LinkContainer>
          )}
        {perDiem
        && (
        <LinkContainer to="/per-diem/requests/admin">
          <MenuItem eventKey="8.4">
            Request With Date
          </MenuItem>
        </LinkContainer>
        )}
        {perDiem
          && (
          <LinkContainer to="/per-diem/paid-not-worked">
            <MenuItem eventKey="8.2">
              Paid Not Worked
            </MenuItem>
          </LinkContainer>
          )}
        {perDiem
          && (
          <LinkContainer to="/per-diem/approvals">
            <MenuItem eventKey="8.3">
              Pending Approval
            </MenuItem>
          </LinkContainer>
          )}
        {perDiem
          && (
          <LinkContainer to="/per-diem/history">
            <MenuItem eventKey="8.5">
              History
            </MenuItem>
          </LinkContainer>
          )}
        {perDiem
        && (
        <LinkContainer to="/per-diem/summary">
          <MenuItem eventKey="8.6">
            Summary
          </MenuItem>
        </LinkContainer>
        )}
      </NavDropdown>
    );
  };

  return (
    /* NOTE: adding color to header to show up in non-production enviornments */
    <React.Fragment>
      { props.showHeader
        && (
        <Navbar fluid style={{ backgroundColor: `${environmentColor}` }}>
          <Navbar.Header>
            <Navbar.Brand>
              <img src={logo} alt="logo" />
            </Navbar.Brand>
          </Navbar.Header>
          <Nav>
            {renderInboxList()}
            {renderReviewList()}
            {renderSubmissionList()}
            {renderApprovalList()}
            {renderReportList()}
            {renderAccountingList()}
            {renderPerDiemList()}
            {renderAdminList()}
          </Nav>
          <Nav pullRight>
            <NavItem eventKey={7} onClick={props.onLogout}>Logout</NavItem>
          </Nav>
        </Navbar>
        )}
    </React.Fragment>
  );
};

Header.propTypes = proptypes;

Header.defaultProps = {
  showHeader: true,
};

const mapDispatchToProps = {
  onLogout: logoutUser,
};

const mapStateToProps = (state) => {
  return {
    features: getUserFeatures(state),
    environmentColor: getEnvironmentColor(state),
    showHeader: getShowHeader(state),
  };
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withRouter,
  withRedux,
);

export default enhance(Header);
